import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'calcHoursMinutes'
})
export class CalcHoursMinutesPipe implements PipeTransform {

  transform(value: number, args?: any): any {
    if (value) {
      var h = value / 0xE10;
      var m = value / 0x3C % 0x3C;
      var s = value % 0x3C;
      return Math.trunc(h) == 0 && Math.trunc(m) == 0 ? `${Math.trunc(s)}S` : `${Math.trunc(h)}H ${Math.trunc(m)}M`;
    }
    return null;
  }
}